import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class TMGCourses extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  <p><i>“Everything in this world is made with the help of Arts & Science”. </i></p>

                  <p>The Arts & Science program is structured in such a way that presents students with broad-based logical reasoning and interdisciplinary education. Students who pursue Arts & Science courses develop skills in writing, speaking and critical thinking. MIET provides excellent and essential skill-building techniques for its students to master the course with ease.</p>
				  <p>TMG College of Arts & Science, group of MIET institutions provides a wide range of courses for all its students. With 9 professional undergraduate courses in Commerce and Banking, Management, Science, Information Technology, and Hotel Management and 3 postgraduate courses specializing in commerce, information technology and computer science, TMG College offers its students a vibrant and friendly environment to choose a career that aligns with their goals.</p>


                  </ScrollAnimation>
                  
					<ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
                        <h5 className="mb-0 mt-2">Affiliated to Madras University : </h5>
                            <p><b>Undergraduate Courses</b> offered at TMG College of Arts & Science are:</p>
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Commerce (B.Com)
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Corp Secretaryship (B.Com – CS)
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Info System management (B.Com – ISM)
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Business Administration (BBA)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Computer Science (B.Sc. – CS)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Computer Application (BCA)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Mathematics (B.Sc. – Mathematics)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Hotel Catering & Management (B.Sc. – HCM)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Electronic Science (B.Sc. – ES)
								</li>
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>		
                    <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
                            <p><b>Postgraduate Courses</b> offered at TMG College of Arts & Science are:</p>
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />Master of Commerce (M. Com)
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. – Information Technology (M.Sc. – IT)
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. – Computer Science (M.Sc. – CS)
								</li>
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>	
                    <ScrollAnimation animateIn="fadeInRight">
                    <h5 className="mb-0 mt-2">Campus Facilities: </h5>
                        <p>
                        At TMG, we believe that to facilitate a quality foundation for remarkable careers, students should get the facilities and services to develop the intellectual, physical, creative and moral spirit. We shape our students to be not the seeker but creator of profession.
                        </p>

                    </ScrollAnimation>		
                    <ScrollAnimation animateIn="fadeInRight">
                        <ul>
                            <li>Congenial environment for a comprehensive education</li>
                            <li>Well-build, modern infrastructure</li>
                            <li>Spacious Classrooms</li>
                            <li>State-of-the-art, well equipped laboratories</li>
                            <li>A gateway to knowledge: Library</li>
                            <li>To lighten the mood: Cafeteria</li>
                            <li>Indoor & outdoor Sports Facilities</li>
                            <li>Hostel & Transportation facility</li>
                            <li>Affordable fee structure</li>
                        </ul>
                    </ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
                        <h5 className="mb-0 mt-2">Why should you choose TMG College of Arts & Science?</h5><br/>							
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> A strong methodology for learning
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Pioneer in research and innovation
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Strong emphasis on extracurricular activities
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> National and international collaborations
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" /> Diverse placement opportunities in the corporate, public, and entrepreneurial sectors.
								</li>
                                {/* <b>Not just theory, we help you gain practical skills too!</b> */}
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>	
                    <ScrollAnimation animateIn="fadeInRight">
                        <h5 className="mb-0 mt-2">A life outside the classroom:</h5>
                        <p>The overall development of a student and his usage of learnt skills and knowledge is determined by extra Curricular activities. AT TMG, a life outside the classroom blended with sports activities form an integral part of a student’s life.</p>
                    </ScrollAnimation><br/>
                    <ScrollAnimation animateIn="fadeInRight">
                        <h5 className="mb-0 mt-2">Making your college life memorable: Events</h5>
                        <p>Our life is a collage of fun events and beautiful memories that come along with it. At TMG, we make sure our students have ample opportunities to create these beautiful memories.</p>
                    </ScrollAnimation><br/>
                    <ScrollAnimation animateIn="fadeInRight">
                        <h5 className="mb-0 mt-2">Career Guidance</h5>
                        <p>Career guidance programmes are offered to our students to help them plan their higher education and identify other opportunities. Campus recruitment by eminent organizations is also held annually.</p>
                    </ScrollAnimation><br/>
                    <ScrollAnimation animateIn="fadeInRight">
                        <h5 className="mb-0 mt-2">A guide to your future: Placements</h5>
                        <p>The objective of the Placement Cell is to provide a platform that would bridge various companies with our talented students who have been nurtured with the best to – Be The Best wherever they go.</p>
                    </ScrollAnimation>	
					<ScrollAnimation animateIn="fadeInRight">
				  	<div className='blog-details-page-content'>
					<blockquote>
						<h5 className="mb-0 mt-2">Application Form:</h5><br/>
						<a href="https://tmgcollege.edu.in/application-form/" target='_blank'><button className="btn btn-base" style={{color:'white',fontWeight:'700'}}>Visit</button></a>
					</blockquote>
					</div>
					</ScrollAnimation>	
				  </div>
		      </div>
			  <Sidebar courseRestriction="TMG College of Arts & Science"/>
		    </div>
		  </div>
		</div>

        }
}

export default TMGCourses